<template>
  <div>
    <!-- nav -->
    <search-nav @handleSearch="onClickSearch">
      <div class="search-layout w-full grid col-gap-4 flex-wrap xl:flex">
        <component
          v-for="(component, index) in stdSearchComponents"
          :key="`search-${index}`"
          v-if="showSearchNavItem(component['options'])"
          :is="component['component']"
          :label="component['label']"
          :query="component['query']"
          :options="component['options']"
          :onClickSearch="onClickSearch"
          v-model="nav.value[component['value']]"
        />
      </div>
    </search-nav>

    <!-- 목록-->
    <div class="w-full">
      <div class="flex">
        <div class="flex mr-auto mb-4">
          <vs-select v-model="perPage" autocomplete class="mr-4" style="width: 110px">
            <vs-select-item v-for="v in [10, 20, 30, 50]" :key="`per-${v}`" :text="`${v}개씩 보기`" :value="v" />
          </vs-select>
        </div>
        <div class="flex ml-auto">
          <vs-button color="secondary" type="border" @click="onClickDownload">Excel 다운로드</vs-button>
        </div>
      </div>
      <!-- total -->
      <div class="pl-2 xl:pl-0 mb-4 flex flex-wrap items-center" style="font-size: 18px">
        <span class="mr-2" style="font-weight: 700">표시된 개수 : </span>
        <span v-html="total"></span>
      </div>

      <div class="w-full overflow-x-auto">
        <table class="w-full">
          <colgroup>
            <col width="100px" />
            <col width="100px" />
            <col width="100px" />
            <col width="100px" />
            <col width="100px" />
            <col width="100px" />
            <col width="100px" />
          </colgroup>
          <thead>
            <tr>
              <th><div style="min-width: 100px">사업장명</div></th>
              <th><div style="min-width: 100px">구분</div></th>
              <th><div style="min-width: 100px">자체 관리번호</div></th>
              <th><div style="min-width: 100px">설치일</div></th>
              <th><div style="min-width: 100px">합격번호</div></th>
              <th><div style="min-width: 100px">최근 안전검사일</div></th>
              <th><div style="min-width: 100px">차기 안전검사일</div></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in list" :key="`row-${index}`" class="row-link" @click="onClickRow(row)">
              <td>{{ row.사업장명 }}</td>
              <td>{{ row.구분 }}</td>
              <td>{{ row.자체관리번호 }}</td>
              <td>{{ row.설치일 }}</td>
              <td>{{ row.합격번호 }}</td>
              <td>{{ row.최근안전검사일 }}</td>
              <td :class="{ completed: alarmCompleted(row) }">{{ row.차기안전검사일 }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 페이지네이션 -->
      <div class="vs-con-table">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination :total="lastPage" v-model="page"></k-pagination>
        </div>
      </div>
    </div>

    <popup-excel-download v-model="download" :list="excelList" title="산업안전보건법_안전부문_유해위험기계기구_총계현황" />
  </div>
</template>

<script>
import singlePageList from "@/views/boards/single-page/listIndex";
import searchComponent from "@/views/list/components/include";
import KPagination from "@/components/kPagination/kPagination.vue";
import SearchNav from "@/components/nav/SearchNav.vue";
import PopupExcelDownload from "@/popup/PopupExcelDownload.vue";

export default {
  name: "TableListPage",
  components: {
    PopupExcelDownload,
    KPagination,
    SearchNav,
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    boardId() {
      return this.$route.params.boardId;
    },
    // 엑셀 다운로드용 목록 (이동용 postId, boardId 는 제외)
    excelList() {
      return this.list.map((row) => {
        const excelRow = { ...row };
        delete excelRow.postId;
        delete excelRow.boardId;
        return excelRow;
      });
    },
    stdSearchComponents() {
      if (singlePageList[`${this.boardId}_list`]) {
        const getComponents = singlePageList[`${this.boardId}_list`].components;
        if (getComponents) {
          const stdSearchComponents = getComponents();
          if (stdSearchComponents && stdSearchComponents.length > 0) {
            for (const component of stdSearchComponents) {
              component.component = searchComponent[component["component"]];
            }
          }
          return stdSearchComponents;
        }
      }
      return [];
    },

    total() {
      const 구분종류 = ["크레인", "압력용기", "컨베이어", "국소배기장치", "전단기", "산업용로봇"];

      let total = `<span class="mr-2" style="font-size: 18px;">총 ${this.totalCount}대</span>`;
      total += "(";

      // board_counts가 있는 경우 이를 사용
      if (Object.keys(this.boardCounts).length > 0) {
        for (const 구분 of 구분종류) {
          let boardId = 0;
          if (구분 === "크레인") boardId = 747;
          else if (구분 === "압력용기") boardId = 748;
          else if (구분 === "컨베이어") boardId = 749;
          else if (구분 === "국소배기장치") boardId = 750;
          else if (구분 === "전단기") boardId = 751;
          else if (구분 === "산업용로봇") boardId = 752;

          const count = this.boardCounts[boardId] || 0;
          total += `<span style="font-size: 15px;">${구분} : ${count}대</span>, `;
        }
      } else {
        // board_counts가 없는 경우(단일 게시판 조회) 구분별 카운트 사용
        for (const 구분 of 구분종류) {
          const count = this.구분Count[구분] || 0;
          total += `<span style="font-size: 15px;">${구분} : ${count}대</span>, `;
        }
      }

      total = total.slice(0, -2);
      total += ")";
      return total;
    },
  },
  data() {
    return {
      nav: {
        value: {},
      },
      perPage: 20,
      page: 1,
      lastPage: 1,
      totalCount: 0,
      list: [],
      구분Count: {},
      boardCounts: {},
      download: false,
    };
  },
  watch: {
    perPage() {
      this.page = 1;
      this.loadList();
    },
    page() {
      this.loadList();
    },
    // 년, 월, 사업장, 구분 값이 변경되면 바로 검색
    "nav.value.year"() {
      this.page = 1;
      this.loadList();
    },
    "nav.value.month"() {
      this.page = 1;
      this.loadList();
    },
    "nav.value.field"() {
      this.page = 1;
      this.loadList();
    },
    "nav.value.type"() {
      this.page = 1;
      this.loadList();
    },
  },
  created() {
    this.loadList();
  },
  methods: {
    async loadList() {
      const conditions = [];
      // 월
      const dateKey = "body.subInfo.설치일";

      if (this.nav.value.year) {
        const year = Number(`${this.nav.value.year}`);
        if (this.nav.value.month) {
          const month = Number(`${this.nav.value.month}`).toString().padStart(2, "0");

          if (month > 0) {
            conditions.push({ key: dateKey, operator: "LIKE", value: `${year}-${month}-%` });
          } else {
            conditions.push({ key: dateKey, operator: "LIKE", value: `${year}-%` });
          }
        } else {
          // 월 전체 선택시
          conditions.push({ key: dateKey, operator: "LIKE", value: `${year}-%` });
        }
      } /*년도가 선택되지 않고, 월이 선택된 경우에는 해당 월만 검색한다.*/ else if (this.nav.value.month) {
        const month = Number(`${this.nav.value.month}`).toString().padStart(2, "0");
        if (month > 0) {
          conditions.push({ key: dateKey, operator: "LIKE", value: `%-${month}-%` });
        }
      }

      // 사업장
      if (this.nav.value.field) {
        conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: this.nav.value.field.fieldId });
      }

      // 구분 (boardId)
      let searchBoardId = "";
      if (this.nav.value.type) {
        if (this.nav.value.type === "크레인") {
          searchBoardId = 747;
        } else if (this.nav.value.type === "압력용기") {
          searchBoardId = 748;
        } else if (this.nav.value.type === "컨베이어") {
          searchBoardId = 749;
        } else if (this.nav.value.type === "국소배기장치") {
          searchBoardId = 750;
        } else if (this.nav.value.type === "전단기") {
          searchBoardId = 751;
        } else if (this.nav.value.type === "산업용로봇") {
          searchBoardId = 752;
        }
      }
      // 검색조건
      const heads = singlePageList[`${this.boardId}_list`].getHead().map((e) => {
        return { [e.name]: e.key };
      });
      // 배열의 객체들을 하나의 객체로 합치기
      const types = Object.assign({}, ...heads);
      if (this.nav.value.column && this.nav.value.column.keyword) {
        conditions.push({ key: types[this.nav.value.column.head], operator: "LIKE", value: `%${this.nav.value.column.keyword}%` });
      }

      const boardIds = searchBoardId ? [searchBoardId] : [747, 748, 749, 750, 751, 752];
      this.loading(true);

      // withBoardIds 사용해 한 번의 API 호출로 모든 보드의 데이터 가져오기
      if (boardIds.length > 0) {
        try {
          // 첫 번째 보드는 기본 boardId로 사용하고, 나머지는 withBoardIds로 전달
          const primaryBoardId = boardIds[0];
          const otherBoardIds = boardIds.slice(1);
          const response = await this._loadList(primaryBoardId, conditions, otherBoardIds);

          // 페이지네이션 정보 업데이트
          this.totalCount = response.total;
          this.lastPage = response.last_page;

          // API에서 받은 board_counts 저장
          this.boardCounts = response.board_counts || {};

          // 구분별 카운트 계산 (board_counts가 없는 경우 사용)
          this.구분Count = {};

          // 특정 구분(type)이 선택된 경우
          if (this.nav.value.type) {
            const 구분종류 = ["크레인", "압력용기", "컨베이어", "국소배기장치", "전단기", "산업용로봇"];
            // 모든 구분을 0으로 초기화
            for (const 구분 of 구분종류) {
              this.구분Count[구분] = 0;
            }
            // 선택된 구분에는 totalCount 할당
            this.구분Count[this.nav.value.type] = this.totalCount;
          } else {
            // 구분이 선택되지 않은 경우 페이지별 카운트 계산
            for (const boardId of boardIds) {
              let 구분 = "";
              if (boardId === 747) 구분 = "크레인";
              else if (boardId === 748) 구분 = "압력용기";
              else if (boardId === 749) 구분 = "컨베이어";
              else if (boardId === 750) 구분 = "국소배기장치";
              else if (boardId === 751) 구분 = "전단기";
              else if (boardId === 752) 구분 = "산업용로봇";

              // boardId로 필터링하여 개수 세기
              const count = response.data.filter((item) => item.board_id === boardId).length;
              this.구분Count[구분] = count;
            }
          }

          // 데이터 변환
          this.list = response.data.map((value) => {
            let 구분 = "";
            if (value.board_id === 747) {
              구분 = "크레인";
            } else if (value.board_id === 748) {
              구분 = "압력용기";
            } else if (value.board_id === 749) {
              구분 = "컨베이어";
            } else if (value.board_id === 750) {
              구분 = "국소배기장치";
            } else if (value.board_id === 751) {
              구분 = "전단기";
            } else if (value.board_id === 752) {
              구분 = "산업용로봇";
            }

            // postContents를 사용
            const content = value.postContents ? value.postContents : JSON.parse(value.post_content);

            return {
              postId: value.id,
              boardId: value.board_id,
              사업장명: content.body.stdInfo.field_name,
              구분,
              자체관리번호: content.body.subInfo.자체관리번호,
              설치일: content.body.subInfo.설치일,
              합격번호: content.body.subInfo.합격번호,
              최근안전검사일: content.body.subInfo.최근안전검사일,
              차기안전검사일: content.body.subInfo.차기안전검사일,
            };
          });

          // this.list.sort((a, b) => {
          //   const 사업장명 = ["본사", "인천공장", "포항공장", "당진공장", "중앙기술연구소"]
          //   if (사업장명.indexOf(a.사업장명) === 사업장명.indexOf(b.사업장명)) {
          //     return new Date(a.차기안전검사일) - new Date(b.차기안전검사일);
          //   }
          //   return 사업장명.indexOf(a.사업장명) - 사업장명.indexOf(b.사업장명);
          // });
        } catch (e) {
          console.error("Error loading lists:", e);
        }
      }
      this.loading(false);
    },

    // 유해위험기계기구/ 크레인
    async _loadList(boardId, conditions, withBoardIds) {
      const projectId = this.projectId;

      // 메타데이터 키 설정 - 필요한 필드만 요청
      const metaKeys = ["body.stdInfo.field_name", "body.subInfo.자체관리번호", "body.subInfo.설치일", "body.subInfo.합격번호", "body.subInfo.최근안전검사일", "body.subInfo.차기안전검사일"];

      // 페이지네이션 적용
      const options = {
        projectId,
        boardId,
        page: this.page,
        perPage: this.perPage,
        orderTarget: "$body.subInfo.차기안전검사일",
        orderDirection: "ASC",
        conditions,
        withMeta: true, // 메타데이터 포함
        withoutRelation: true, // 관계 데이터 제외
        onlyMeta: true, // 메타데이터만 요청
        metaKeys, // 필요한 메타데이터 필드 지정
        withBoardIds: withBoardIds || [], // 추가로 조회할 boardId 배열
      };

      // 단일 호출로 데이터 반환
      return await this.$store.dispatch("board/LOAD_POST_LIST", options);
    },

    onClickSearch() {
      this.page = 1;
      this.loadList();
    },

    showSearchNavItem(options) {
      if (options && options.visibleKeyValue) {
        for (const keyValue of options.visibleKeyValue) {
          const key = Object.keys(keyValue)[0];
          const value = keyValue[key];
          const navValue = this.findJsonDataWithDottedPath(this.nav.value, key);
          if (navValue !== value) {
            if (Array.isArray(navValue) && navValue.toString() === value) {
              return true;
            }
          } else {
            return true;
          }
        }
        return false;
      }
      return true;
    },

    findJsonDataWithDottedPath(json, path) {
      try {
        const _keys = Object.keys(json);
        if (_keys.length === 0) {
          return "";
        }
        const paths = path.split(".");
        let result = json;
        for (const p of paths) {
          result = result[p];
        }
        return result;
      } catch (err) {
        return "";
      }
    },

    loading(open) {
      const loadingDialog = new CustomEvent("loadingDialog", {
        detail: {
          open,
        },
      });
      window.dispatchEvent(loadingDialog);
    },

    alarmCompleted(row) {
      const now = new Date(new Date().format("yyyy-MM-dd"));
      const n = new Date(row.차기안전검사일);
      // 차기안전검사일 2개월 전
      const n20 = n.addMonths(-2);

      // 현재 날짜가 "차기안전검사일 2개월 전" 시점 이후이면 빨간색으로 표시
      // (차기안전검사일이 이미 지난 경우도 빨간색)
      return now - n20 >= 0;
    },

    // 행 클릭 시 해당 장비 게시글을 전체화면 팝업으로 연다 (결재관리와 동일한 방식)
    // _c_back: 팝업에서 목록 버튼을 누르면 창을 닫는다
    onClickRow(row) {
      if (!row.postId || !row.boardId) return;

      const popup = window.open(`/project/${this.projectId}/tab/${row.boardId}/write/${row.postId}?_c_back=t`, "_blank", `width=${screen.width},height=${screen.height}`);

      // 팝업이 닫히면 수정 내용(차기 안전검사일 등)이 반영되도록 목록 갱신
      const checkPopupClosed = setInterval(() => {
        if (!popup || popup.closed) {
          clearInterval(checkPopupClosed);
          this.loadList();
        }
      }, 500);
    },

    onClickDownload() {
      this.download = true;
    },
  }, // methods
};
</script>

<style lang="scss" scoped>
table {
  border-collapse: collapse !important;
  border-spacing: 0 !important;

  thead {
    & th > div {
      white-space: nowrap;
      padding: 10px;
      margin-top: -1px;
      background-color: #f5f5f5;
    }
  }

  th {
    border: 1px solid #e0e0e0;
    text-align: center;

    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }
  td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    text-align: center;
  }
}

.row-link {
  cursor: pointer;

  &:hover td {
    background-color: #f5f7ff;
  }
}

.completed {
  color: red;
}
</style>
